import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import React, { memo, useRef } from "react";
import { accessObjectByDotSeparatedKeys } from "./util";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

moment.updateLocale("en", {
  week: {
    dow: 1,
  },
});

export const FormDatePicker = memo(
  ({
    name,
    label,
    index,
    minDate,
    maxDate,
    markedDates = [],
    warningDates = [],
  }) => {
    const {
      control,
      formState: { errors },
    } = useFormContext();

    const inputRef = useRef(null);

    function MarkedDay(props) {
      const { day, ...other } = props;
      const formatted = moment(day).format("YYYY-MM-DD");
      const isMarked = markedDates.includes(formatted);
      const isWarning = warningDates.includes(formatted);

      return (
        <PickersDay
          {...other}
          day={day}
          sx={{
            ...(isMarked ? { bgcolor: "#e0e0e0" } : {}),
            ...(isWarning ? { color: "red", fontWeight: "bold" } : {}),
          }}
        />
      );
    }

    return (
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value, name } }) => {
          const onDateChange = (date) => {
            const newValue = date.valueOf();

            // Check if newValue is NaN because, when the input date has prop _isValid: false
            // (for example when writing in the textfield), valueOf() returns NaN
            if (!isNaN(newValue)) {
              onChange(
                index !== undefined && typeof value === "object"
                  ? [
                      ...value.slice(0, index),
                      newValue,
                      ...value.slice(index + 1),
                    ]
                  : moment(newValue),
              );
            }
          };

          return (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                minDate={moment(minDate).toDate()}
                maxDate={moment(maxDate).toDate()}
                inputRef={inputRef}
                label={label}
                value={index !== undefined ? value[index] : value}
                onChange={onDateChange}
                format={"YYYY-MM-DD"}
                slots={
                  markedDates.length > 0
                    ? {
                        day: MarkedDay,
                      }
                    : undefined
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onBlur={onBlur}
                    error={!!accessObjectByDotSeparatedKeys(errors, name)}
                    helperText={
                      accessObjectByDotSeparatedKeys(errors, name)?.message
                    }
                  />
                )}
              />
            </LocalizationProvider>
          );
        }}
      />
    );
  },
);
FormDatePicker.displayName = "FormDatePicker";
